"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DuplicateConnectionError = exports.ImpossibleConnectionSetError = exports.CircularConnectionError = exports.ThermalResistanceValidationError = exports.ThermalCapacitanceValidationError = exports.TemperatureValidationError = exports.NodeNotFoundError = exports.NodeIdValidationError = exports.TotalTimeValidationError = exports.TimeStepValidationError = exports.HotStuffError = void 0;
class HotStuffError extends Error {
    constructor(message) {
        super(message);
        this.name = this.constructor.name;
        this.message = message;
    }
}
exports.HotStuffError = HotStuffError;
class TimeStepValidationError extends HotStuffError {
}
exports.TimeStepValidationError = TimeStepValidationError;
class TotalTimeValidationError extends HotStuffError {
}
exports.TotalTimeValidationError = TotalTimeValidationError;
class NodeIdValidationError extends HotStuffError {
}
exports.NodeIdValidationError = NodeIdValidationError;
class NodeNotFoundError extends HotStuffError {
}
exports.NodeNotFoundError = NodeNotFoundError;
class TemperatureValidationError extends HotStuffError {
}
exports.TemperatureValidationError = TemperatureValidationError;
class ThermalCapacitanceValidationError extends HotStuffError {
}
exports.ThermalCapacitanceValidationError = ThermalCapacitanceValidationError;
class ThermalResistanceValidationError extends HotStuffError {
}
exports.ThermalResistanceValidationError = ThermalResistanceValidationError;
class CircularConnectionError extends HotStuffError {
}
exports.CircularConnectionError = CircularConnectionError;
class ImpossibleConnectionSetError extends HotStuffError {
}
exports.ImpossibleConnectionSetError = ImpossibleConnectionSetError;
class DuplicateConnectionError extends HotStuffError {
}
exports.DuplicateConnectionError = DuplicateConnectionError;
